var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcceptedEula = function SvgAcceptedEula(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.226 2.209h6.104l1.19 1.19V12.2l-1.19 1.19H7.688v-1h3.228l.604-.604V3.813l-.604-.604H5.64l-.604.604v5.912h-1V3.399l1.19-1.19Zm.077 11.863 3-4.497-.832-.555-2.703 4.052h-.415l-1.397-2.04-.826.565 1.696 2.475h1.477Z",
    fill: "currentColor"
  })));
};
export default SvgAcceptedEula;